"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledError = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledError = (0, styles_1.styled)(material_1.Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    overflowY: "auto",
    minHeight: `calc(100vh - ${theme.spacing(16)})`,
    width: "100%",
    marginTop: process.env.NODE_ENV !== "production" ? theme.spacing(4) : 0,
}));
//# sourceMappingURL=styled.js.map